import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Input,
  InputLabel,
  Box,
  TextField,
  Button,
} from '@mui/material'

import { inject, observer } from 'mobx-react'
import RichEditor from '../../components/RichEditor/RichEditor'

const ProposalModal = props => {
  let {
    params,
    open,
    handleClose,
    reason,
    proposalStore,
    selectPeopleStore,
    fileStore,
  } = props
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw', // Set your width here
            mx: 0,
            zIndex: 50,
          },
        },
      }}>
      <DialogTitle
        id="scroll-dialog-title"
        className="text-xl font-bold text-white pt-3"
        sx={{
          fontWeight: 700,
          backgroundColor: '#2C65AC',
        }}>
        Nội dung
      </DialogTitle>
      <DialogContent>
        <div className="mt-3">
          <RichEditor height="100%" editorContent={reason} />
        </div>
      </DialogContent>
      <DialogActions
        sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: '0' }}>
        <Button
          sx={{ fontWeight: 600 }}
          onClick={handleClose}
          className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default inject('proposalStore')(observer(ProposalModal))
